<template>
  <div>
    <h4 class="text-azul-medio d-none d-lg-block">
      <span>{{titulo}}</span>
      <br />
      {{subTitulo}}
    </h4>
    <h4 class="text-azul-medio mt-4 mov d-block d-lg-none">
      <span>
        {{titulo}}
        <br />
        {{subTitulo}}
      </span>
    </h4>
  </div>
</template>

<script>
export default {
  name: "Titulo",
  props: {
    titulo: {
      type: String
    },
    subTitulo: {
      type: String
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/paginas/TituloPagina.vue